import { Icons } from '@/components/icons';
import { cn } from '@/lib/cn';
import PigelloLogoNoText from '@/public/assets/logo/pigello_blue.svg';
import Image, { type ImageProps } from 'next/image';
import { useState } from 'react';

type LogoWithFallbackProps = Omit<ImageProps, 'src'> & {
  src?: ImageProps['src'];
};

export function LogoWithFallback(props: LogoWithFallbackProps) {
  const { src, className, alt, ...rest } = props;
  const [hasError, setHasError] = useState(false);
  return (
    <div
      className={cn(
        'flex items-center justify-center overflow-hidden rounded-md border bg-surface p-1',
        className
      )}
    >
      {!src || hasError ? (
        <div className='flex size-full items-center justify-center rounded-md bg-subtle'>
          <Icons.image className='h-1/2 w-1/2 text-muted-foreground' />
        </div>
      ) : (
        <Image
          {...rest}
          src={src}
          alt={alt || 'Service logo'}
          className='size-full rounded-sm object-contain'
          onError={() => setHasError(true)}
        />
      )}
    </div>
  );
}

export const PigelloLogo = ({ className }: { className?: string }) => {
  return (
    <Image
      width={80}
      height={80}
      src={PigelloLogoNoText.src}
      alt={`Pigello logga`}
      className={className}
    />
  );
};
